import React, { useState } from 'react';
import axios from 'axios';
import { utmPayload } from '../lib/tracking';
import { toast } from '../hooks/use-toast';
import Testimonials from '../components/Testimonials';
import HomeHero from '../components/home/HomeHero';
import HomeWineOfTheYearBanner from '../components/home/HomeWineOfTheYearBanner';
import HomeWelcome from '../components/home/HomeWelcome';
import HomeProcess from '../components/home/HomeProcess';
import HomeParallax from '../components/home/HomeParallax';
import HomeCTA from '../components/home/HomeCTA';
import HomeNewsletter from '../components/home/HomeNewsletter';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const INITIAL_NEWSLETTER = {
  firstName: '',
  lastName: '',
  email: '',
  referralCode: '',
};

const Home = ({ onBookCall }) => {
  const [newsletter, setNewsletter] = useState(INITIAL_NEWSLETTER);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await axios.post(`${API}/newsletter/subscribe`, {
        firstName: newsletter.firstName,
        lastName: newsletter.lastName,
        email: newsletter.email,
        ...utmPayload(),
      });
      if (response.data.success) {
        toast({
          title: 'Success!',
          description: response.data.message || "You're now on our VIP list. Welcome to The Lokal family!",
        });
        setNewsletter(INITIAL_NEWSLETTER);
      }
    } catch (error) {
      if (error.response?.status === 409) {
        toast({
          title: 'Already Subscribed',
          description: "You're already on our VIP list!",
          variant: 'destructive',
        });
      } else {
        toast({
          title: 'Subscription Failed',
          description: error.response?.data?.detail || 'Something went wrong. Please try again.',
          variant: 'destructive',
        });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen">
      <HomeHero />
      <HomeWineOfTheYearBanner />
      <HomeWelcome />
      <HomeProcess />
      <HomeParallax onBookCall={onBookCall} />
      <HomeCTA onBookCall={onBookCall} />
      <Testimonials />
      <HomeNewsletter
        newsletter={newsletter}
        setNewsletter={setNewsletter}
        onSubmit={handleNewsletterSubmit}
        isSubmitting={isSubmitting}
      />
    </div>
  );
};

export default Home;
